module.exports = __webpack_public_path__ + "media/images/manage-offer/file-95859fd119e025821e768a75935c5463.png";